// extracted by mini-css-extract-plugin
export var logo = "_k5-2";
export var logoWrapper = "_k5-1";
export var strip = "_k5-0";